// One email's status where it was sent (Marius round 5, EM3): waiting to be
// sent, sent, trying again, not sent. "Sent" means handed to the mail service;
// whether it then reached the inbox is not something Convenor can see.
//   <MailStatusLine mail={row.mail} />            a tag and, when useful, a sentence
//   <MailStatusLine mail={row.mail} showTo />     with the address it went to
import type { MailStatus, MailStatusKey } from "@convenor/shared/v3";
import { formatDateTime } from "../../lib/format";
import { StatusPill, type Tone } from "../../ui";

const LOOK: Record<MailStatusKey, { label: string; tone: Tone }> = {
  queued: { label: "Email waiting to be sent", tone: "info" },
  sent: { label: "Email sent", tone: "success" },
  retrying: { label: "Email not sent yet", tone: "warning" },
  failed: { label: "Email not sent", tone: "danger" },
  not_sent: { label: "Not emailed", tone: "neutral" },
};

/** True while the status can still change by itself (the screen may refresh). */
export const mailPending = (m: MailStatus | null | undefined): boolean => m?.status === "queued" || m?.status === "retrying";

/** Refresh every 5 seconds while any of these emails is still on its way. */
export const refreshWhilePending = (mails: (MailStatus | null | undefined)[]): number | false => (mails.some(mailPending) ? 5_000 : false);

export function MailStatusLine({ mail, showTo = false }: { mail: MailStatus | null | undefined; showTo?: boolean }) {
  if (!mail) return null;
  const look = LOOK[mail.status];
  const when = mail.at ? formatDateTime(mail.at) : null;
  return (
    <span className="mail-status">
      <StatusPill label={mail.status === "sent" && when ? `${look.label} ${when}` : look.label} tone={look.tone} />
      {showTo && mail.to ? <span className="table__sub">To {mail.to}</span> : null}
      {mail.note ? (
        <span className="table__sub">
          {mail.note}
          {mail.status === "retrying" && when ? ` Next try: ${when}.` : ""}
        </span>
      ) : null}
    </span>
  );
}
